//
//
// document.addEventListener("DOMContentLoaded", () => {
//
//     if (document.getElementById('uniqueHash')) {
//         function generateHash() {
//             var hash = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
//             return hash;
//         }
//
//         var uniqueHash = generateHash();
//         document.getElementById('uniqueHash').value = uniqueHash;
//         localStorage.setItem('uniqueHash', uniqueHash);
//     }
//
//     if (localStorage.getItem('uniqueHash')) {
//         let storedHash = localStorage.getItem('uniqueHash');
//
//         if (storedHash && document.querySelector('a.dynmamicHashedLink')) {
//
//             var anchor = document.querySelector('a.dynmamicHashedLink');
//
//             if (anchor) {
//                 var originalHref = anchor.getAttribute('href');
//
//                 anchor.setAttribute('href', originalHref + storedHash);
//             }
//         }
//     }
//
// });
